import { useDebugValue } from 'react';
import { RootState } from 'src/store';
import { useSelector } from 'react-redux';

export const useDeviceEventsState = (): RootState['deviceEvents'] => {
  const state = useSelector<RootState, RootState['deviceEvents']>(
    (state) => state.deviceEvents,
  );

  useDebugValue(state);

  return state;
};
